export const MAIN_SET_MESSAGE    = "MAIN_SET_MESSAGE";
export const MAIN_SET_FETCHING   = "MAIN_SET_FETCHING";

export const CATEGORIES_SET_DATA = "CATEGORIES_SET_DATA";
export const PRODUCTS_SET_DATA   = "PRODUCTS_SET_DATA";
export const SET_TOKEN           = "SET_TOKEN";
export const SET_USER            = "SET_USER";
export const LOGOUT              = "LOGOUT";